// @need-translate
import {twMerge} from '../../../common/twMerge';
import IsmsLogo from './isms-logo.png';
import IsoIe from './iso-ie.png';

export function PrivacySafe({isMobile}: {isMobile?: boolean}) {
  return (
    <>
      <header>카카오페이지 정보보호 안내</header>
      <main>
        <section>
          <h2>ISMS (정보보호 관리체계) 인증</h2>
          <div className={twMerge('mt-0!', !isMobile && 'flex flex-row')}>
            <div className="mt-0!">
              <p>
                ISMS 인증은 기업이 정보보호를 위한 일련의 조치와 활동들을
                지속적으로 수행하고 있는 것을 증명하는 것으로 한국인터넷진흥원이
                인증하는 정보보호 인증제도 입니다. 카카오페이지는 2020년 6월
                정보보호 관리체계가 높은 수준으로 엄격하게 실행되고 있는 것으로
                평가받아 본 ISMS 인증을 취득하였습니다.
                <br />
                <br />
                인증범위 : 종합 컨텐츠 플랫폼 운영(카카오페이지)
                <br />
                <br />
                인증기간 : 2020.06.10 ~ 2023.06.09
              </p>
            </div>
            <img
              src={IsmsLogo}
              alt="정보보호 관리체계 인증"
              className={twMerge(
                'mb-28pxr ml-64pxr w-232pxr',
                isMobile && 'mt-46pxr mb-48pxr'
              )}
            />
          </div>
        </section>
        <section>
          <h2>
            ISO/IEC 27001, 27701 (정보보호 및 개인정보 관리체계 국제규격) 인증
          </h2>
          <div className={twMerge('mt-0!', !isMobile && 'flex flex-row')}>
            <p>
              ISO/IEC 27001 인증은 국제표준화기구(ISO) 및
              국제전기기술위원회(IEC) 에서 제정한 정보보호 관리체계 국제규격
              인증입니다. 카카오페이지는 2020년 6월 카카오페이지 플랫폼 모든
              서비스에 대하여 ISO/IEC 27001:2013 인증과, EU GDPR 등 전세계의
              개인정보보호 요구사항을 충족하는 글로벌 개인정보 관리체계 국제규격
              인증인 ISO/IEC 27701:2019 인증을 취득하였습니다.
            </p>
            <img
              src={IsoIe}
              alt="ISO/IEC 인증"
              className={twMerge(
                'mb-28pxr ml-64pxr w-253pxr',
                isMobile && 'mt-46pxr mb-48pxr'
              )}
            />
          </div>
        </section>
      </main>
    </>
  );
}
